var React = require('react');

function Sign (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M0 80a16 16 0 0 1 16-16h48V16A16 16 0 0 1 80 0h32a16 16 0 0 1 16 16v48h368a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H128v368a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V128H16a16 16 0 0 1-16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M160 384V160h320v224z","className":"fa-primary","key":2})]);
}

Sign.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Sign;

Sign.default = Sign;
